export default {
  classrooms: [],
  classroom: {}
}
